export default __webpack_public_path__ + "static/media/bg.8486a791.jpg";